import React, { useState } from "react";
import { ActionsMenu, MenuItem, ActionMenuDivider } from "ui/actions-menu";
import { TouchpointAttributes } from "hooks/api/use-touchpoints";
import {
  useTouchpointActions,
  type TouchpointActionItem,
} from "containers/admin/clients/campaign/campaign-creative-page/hooks/use-touchpoint-actions";

interface CreativeTableActionsMenuProps {
  touchpoint: TouchpointAttributes;
}

const CreativeTableActionsMenu: React.FC<CreativeTableActionsMenuProps> = ({
  touchpoint,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { actions } = useTouchpointActions(touchpoint);

  const handleMenuOpen = () => setIsOpen(true);
  const handleMenuClose = () => setIsOpen(false);

  return (
    <div className="flex justify-end w-full">
      <ActionsMenu
        itemName={touchpoint.name}
        open={isOpen}
        onOpen={handleMenuOpen}
        onClose={handleMenuClose}
        sx={{ justifyContent: "flex-end" }}>
      {actions.map((item, index) => {
        if ("type" in item && item.type === "divider") {
          return <ActionMenuDivider key={`divider-${index}`} />;
        }

        const action = item as TouchpointActionItem;
        return (
          <MenuItem
            key={action.label}
            icon={action.icon}
            label={action.label}
            onClick={() => {
              action.onClick();
              setIsOpen(false);
            }}
          />
        );
      })}
    </ActionsMenu>
    </div>
  );
};

export default CreativeTableActionsMenu;
